"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListIcon = void 0;
const tslib_1 = require("tslib");
const components_1 = require("@bluebase/components");
const ListItemIcon_1 = tslib_1.__importDefault(require("@material-ui/core/ListItemIcon"));
const react_1 = tslib_1.__importDefault(require("react"));
exports.ListIcon = (_a) => {
    var { styles = {} } = _a, rest = tslib_1.__rest(_a, ["styles"]);
    return (react_1.default.createElement(ListItemIcon_1.default, null,
        react_1.default.createElement(components_1.Icon, Object.assign({ color: styles.color }, rest))));
};
exports.ListIcon.defaultProps = components_1.ListIconDefaultProps;
exports.ListIcon.defaultStyles = (theme) => ({
    color: theme.palette.action.active,
});
